import styled from "styled-components";

const Style = styled.div`
  display: flex; 
  flex-direction: column;
  flex: 1;

  .decline-icon {
    background: var(--error-60);
    width: 32px;
    height: 32px;
    border-radius: 100%;
    
    svg {
      width: 14px;
      height: 14px;
      color: white;
    }
  }
`;

export default Style;
